import MCPTools from "../../../../src/components/Docs/MCPTools";
import * as React from 'react';
export default {
  MCPTools,
  React
};